import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import logo from "../assets/shared image.png";
import personImg from "../assets/toursImages/profile nav bar icon (1).svg";
import VisaIcon from "../assets/toursImages/visa main module.png";
import umbrellaImg from '../assets/toursImages/holiday main module dark purple icon.svg';
import style from "../components/Toursnavbar.module.css";
import { Modal, Button } from 'react-bootstrap';

function Toursnavbar() {
  const [isHovered, setIsHovered] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const HoverEffect = (buttonId) => ({
    backgroundColor: isHovered === buttonId ? "rgba(84, 28, 156, 1)" : 'transparent',
    color: isHovered === buttonId ? 'white' : 'black',
    cursor: 'pointer',
  });

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <nav className="navbar navbar-expand-lg bg-white" style={{ height: "70px", padding: "5px 5px" }}>
      <div className="container-fluid d-flex justify-content-between align-items-center">
        
        {/* Logo */}
                  <img
                    src={logo}
                    width={110}
                    alt="logo"
                    className="img-fluid"
                    style={{ height: "43px", margin: "0", cursor: "pointer" }}
                    onClick={() => navigate("/")}
                  />
        
        {/* Hero icons */}
        <div>
          <ul className={`navbar-nav me-auto mb-0 mt-1 ${style.heroSection}`}>
            <li className={`nav-item me-2 ${style.Libtns}`}>
              <button className={`d-flex flex-row rounded-pill border-0 ps-3 pe-3 ${style.purpleHover}`} 
                style={{ height: "40px", padding: "8px 15px" }}>
                <img src={umbrellaImg} alt="tour" className={`me-2 ${style.imgColor}`} width={28} height={28} />  
                <span className={`d-flex flex-row ${style.btnHover}`} style={{ fontSize: "16px", fontWeight: "500" }}>Holiday</span>
              </button>
            </li>
            <li className="nav-item me-2">
              <button 
                className={`d-flex flex-row rounded-pill border-0 ps-3 pe-3 ${style.purpleHover}`}  
                onClick={() => handleNavigation("/visa")} 
                style={{ height: "40px", padding: "8px 15px" }}
              >
                <img src={VisaIcon} alt="flights" className={`me-2 ${style.imgColor}`} width={28} height={28} />
                <span className={`d-flex flex-row ${style.btnHover}`} style={{ fontSize: "16px", fontWeight: "500" }}>Visa</span>
              </button>
            </li>
          </ul>
        </div>

        {/* User Profile with Modal */}
        <div 
          className="border-0 ps-2 pe-2 btn rounded-pill d-flex flex-row align-items-center justify-content-center" 
          style={{ height: "35px", background: "radial-gradient(50% 50%, rgba(164, 122, 255, 0.3), rgba(198, 172, 252, 0.3))" }}
          onClick={() => setShowModal(true)}
        >
          <img src={personImg} alt="profile" width={30} height={25} />
          <span className="ps-2 pe-2" style={{ fontSize: "14px" }}></span>
        </div>

       
      </div>
    </nav>
  );
}

export default Toursnavbar;
